import synccc from "../img/synccc.png"
import jomato from "../img/jomato.jpg"
import self from "../img/self.png"
import useMemo from "../img/usememo.jpg"
import vpn from "../img/vpn.png"
import cloud from "../img/cloud.png"
import punjab from "../img/punjab.png"
import jobrocket from "../img/jobrocket.png"
import albertsons from "../img/albertsons.png"
import heyhub from "../img/heyhub.jpeg"

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];

export let singlePage = false;

export const info = {
    firstName: "Nav",
    lastName: "Rana",
    initials: "navJS",
    position: "a Software Engineer",
    selfPortrait: self,
    gradient: `-webkit-linear-gradient(135deg, ${colors})`,
    baseColor: colors[0],
    miniBio: [
        {
            emoji: '📱',
            text: '8+ years of iOS · Swift · SwiftUI'
        },
        {
            emoji: '🌐',
            text: 'full-stack · React · Node.js · MongoDB'
        },
        {
            emoji: '🇨🇦',
            text: 'based in Toronto, Canada'
        },
        {
            emoji: '🐈',
            text: 'dad to a wonderful daughter & a few cats'
        },
        {
            emoji: '📧',
            text: 'hi@navjs.co'
        }
    ],
    socials: [
        {
            link: "https://github.com/nav-ios",
            icon: "fa fa-github",
            label: 'github'
        },
        {
            link: "https://www.linkedin.com/in/navrana/",
            icon: "fa fa-linkedin",
            label: 'linkedin'
        },
        {
            link: "https://www.youtube.com/@Navjs-co",
            icon: "fa fa-youtube",
            label: 'youtube'
        },
        {
            link: "https://www.instagram.com/navjs.co",
            icon: 'fa fa-instagram',
            label: 'instagram'
        }
    ],
    bio: `I'm Navdeep, a software engineer with 8+ years of experience building native iOS apps and full-stack web products. On the mobile side, I specialise in Swift, SwiftUI, and UIKit — having shipped apps used by millions including Albertsons Safeway. On the web side, I build with React, Node.js, and MongoDB. I'm language-agnostic and care most about clean architecture, great UX, and shipping things that work. Currently based in Toronto 🇨🇦 and open to senior engineering roles.`,
    resumeUrl: '/Navdeep_Rana_Resume.pdf',
    skills: {
        proficientWith: ['swift', 'swiftui', 'uikit', 'xcode', 'combine', 'core data', 'cocoapods', 'spm', 'xctest', 'appium', 'react', 'node.js', 'express', 'mongodb', 'javascript', 'typescript', 'git', 'docker', 'ci/cd'],
        exposedTo: ['firebase', 'flutter', 'python', 'tailwind', 'php']
    },
    hobbies: [
        {
            label: 'home lab & self-hosting',
            emoji: '🖥️'
        },
        {
            label: 'movies & film',
            emoji: '🎥'
        },
        {
            label: 'working out',
            emoji: '🏋️'
        },
        {
            label: 'cooking',
            emoji: '🌶'
        }
    ],
    portfolio: [
        {
            title: "EarPods USB-C — Honest Review",
            live: "https://www.youtube.com/@Navjs-co",
            source: "https://www.youtube.com/@Navjs-co",
            image: useMemo
        },
        {
            title: "TrueNAS VPN Setup using Docker",
            live: "https://www.youtube.com/watch?v=-Ae6Mk6u3WA",
            source: "https://www.youtube.com/watch?v=-Ae6Mk6u3WA",
            image: vpn
        },
        {
            title: "Setting up Cloudflared on TrueNAS for Global Access",
            live: "https://www.youtube.com/watch?v=LZNio-ghzBg",
            source: "https://www.youtube.com/watch?v=LZNio-ghzBg",
            image: cloud
        }
    ],
    work: [
        {
            title: "synccc — CC Statements to Calendar, Automated",
            live: "https://github.com/nav-ios/synccc",
            source: "https://github.com/nav-ios/synccc",
            image: synccc,
            buttonText: "View on GitHub",
            icon: "fa fa-github"
        },
        {
            title: "chomato — Zomato Food Rescue MQTT Monitor",
            live: "https://github.com/nav-ios/chomato",
            source: "https://github.com/nav-ios/chomato",
            image: jomato,
            buttonText: "View on GitHub",
            icon: "fa fa-github"
        },
        {
            title: "Albertsons Safeway — Principal iOS Engineer",
            live: "https://apps.apple.com/us/app/safeway-deals-delivery/id521487551",
            source: "https://apps.apple.com/us/app/safeway-deals-delivery/id521487551",
            image: albertsons
        },
        {
            title: "HeyHub — Senior iOS Developer",
            live: "https://heyhub.com/",
            source: "https://heyhub.com/",
            image: heyhub
        },
        {
            title: "JobRocket — Full-Stack Founder",
            live: "http://jobrocket.co",
            source: "http://jobrocket.co",
            image: jobrocket
        },
        {
            title: "Punjab Kesari — iOS Developer",
            live: "https://apps.apple.com/in/app/punjab-kesari/id576495885",
            source: "https://apps.apple.com/in/app/punjab-kesari/id576495885",
            image: punjab
        }
    ]
}
